import React from "react"
import { Link } from "gatsby"

const StatsStrip = ({
  topicCount,
  communityCount,
  platformCount,
  lastUpdated,
}) => {
  return (
    <section className="mb-12 reveal" aria-labelledby="home-stats-heading">
      <div className="max-w-5xl mx-auto bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        {/* Text block: left-aligned to avoid centered-text wrapping issues */}
        <div className="px-6 py-8 sm:px-10 sm:py-10 lg:px-12">
          <div className="max-w-2xl">
            <p className="section-eyebrow">The Hive Index</p>
            <h2
              id="home-stats-heading"
              className="mt-2 text-2xl font-extrabold text-gray-900 sm:text-3xl tracking-tight"
            >
              The internet&apos;s go-to community directory
            </h2>
            <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
              Finding the right community used to mean knowing the right people. We fixed that.
              Hive Index is a free, searchable directory of{" "}
              {communityCount.toLocaleString()} online communities, organized so anyone can
              find exactly where their people are.
            </p>
            <p className="mt-3 text-sm sm:text-base text-gray-500">
              Know a community we missed?{" "}
              <Link to="/submit/" className="text-rose-600 font-semibold hover:underline">
                Submit it for free.
              </Link>{" "}
              Want a new topic?{" "}
              <Link to="/suggest/" className="text-rose-600 font-semibold hover:underline">
                Suggest it.
              </Link>
            </p>
            {lastUpdated ? (
              <div className="pt-4 border-gray-100 flex items-center gap-2">
                <span
                  className="inline-block w-2 h-2 rounded-full bg-green-400 flex-shrink-0"
                  aria-hidden="true"
                />
                <p className="text-sm text-gray-400 font-medium">
                  Curating communities since 2021, last updated{" "}
                  <span className="text-gray-600">{lastUpdated}</span>
                </p>
              </div>
            ) : null}
          </div>
        </div>

        {/* Stats row */}
        <div className="border-t border-gray-100">
          <dl className="grid grid-cols-3 divide-x divide-gray-100">
            <div className="flex flex-col px-6 py-5 sm:px-8 sm:py-6 text-center">
              <dd className="text-3xl sm:text-4xl font-extrabold text-amber-600 tabular-nums">
                {communityCount.toLocaleString()}
              </dd>
              <dt className="mt-1.5 text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wide">
                <Link to="/communities/" className="hover:text-rose-600">
                  Communities
                </Link>
              </dt>
            </div>
            <div className="flex flex-col px-6 py-5 sm:px-8 sm:py-6 text-center">
              <dd className="text-3xl sm:text-4xl font-extrabold text-amber-600 tabular-nums">
                {typeof topicCount === "number"
                  ? topicCount.toLocaleString()
                  : topicCount}
              </dd>
              <dt className="mt-1.5 text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wide">
                <Link to="/topics/" className="hover:text-rose-600">
                  Topics
                </Link>
              </dt>
            </div>
            <div className="flex flex-col px-6 py-5 sm:px-8 sm:py-6 text-center">
              <dd className="text-3xl sm:text-4xl font-extrabold text-amber-600 tabular-nums">
                {platformCount}
              </dd>
              <dt className="mt-1.5 text-xs sm:text-sm font-medium text-gray-500 uppercase tracking-wide">
                <Link to="/platforms/" className="hover:text-rose-600">
                  Platforms
                </Link>
              </dt>
            </div>
          </dl>
        </div>

       
      </div>
    </section>
  )
}

export default StatsStrip
